import React from "react";
import styled from "styled-components";
import { Styles } from "../../../../../../../config"
import { normalizeString } from "../../../../../../../util/functions";

const _getButtonLength = ({ length }) => {
  let ret = 100;
  ret += length * 5;
  return ret;
};
const SlateTableWrapper = styled.table`
  width: 100%;
`;

export const SlateTable = (props) => {
  return <SlateTableWrapper {...props}></SlateTableWrapper>;
};

export const SlateButton = (props) => {


  return (
    <div style={{ padding: "10px 0px" }}>
      <table>
        <tbody>
          <tr>
            <td
              height="60"
              width={
                props.children[0]?.props?.text?.text?.length
                  ? _getButtonLength({
                    length: props.children[0]?.props?.text?.text?.length,
                  })
                  : "300"
              }
              style={{
                borderRadius: "5px",
                backgroundColor: props.background || "#7fc2ff",
                textAlign: "center",
                verticalAlign: "middle",
              }}
              //@ts-ignore
              bgcolor={props.background || "#7fc2ff"}
            >
              <a
                style={{
                  color: Styles.Color.primary,
                  textDecoration: "none",
                  width: "100%",
                  height: "100%",
                  textAlign: "center",
                  display: "inline-block",
                  cursor: "pointer",
                }}
                href={`{host}/${props.link}`}
              >
                <strong
                  style={{
                    color: Styles.Color.white,
                    textDecoration: "none",
                    fontSize: "18px",
                    paddingTop: "20px",
                    paddingBottom: "20px",
                    cursor: "pointer",
                    display: "inline-block",
                  }}
                >
                  {normalizeString({
                    data: props.children[0]?.props?.text?.text,
                    actions: ["nobreak"],
                  })}
                </strong>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export const SlateTextButton = (props) => {
  return (
    <a
      style={{ textDecoration: "none", color: props.color || "#465578" }}
      href={`{host}/${props.link}`}
    >
      {props.children}
    </a>
  );
};
